import { MagnifyingGlass } from '@phosphor-icons/react';
import { Flex, Input } from 'antd';
import { IconSizes } from '@utility/constants/style-contants';

export function InboundListToolbar({ search, onSearchChange }) {
  return (
    <Flex align="center" gap={8} wrap="nowrap" style={{ marginLeft: 'auto' }}>
      <Input
        placeholder="Search shipments"
        value={search ?? ''}
        onChange={e => onSearchChange(e.target.value)}
        allowClear
        prefix={<MagnifyingGlass size={IconSizes.small} />}
        style={{ width: 240 }}
      />
    </Flex>
  );
}
